//@flow
import React from "react";
import { useSelector } from "react-redux";
import { Maybe } from "ramda-fantasy";
import SelecaoDataInicialEFinal, {
  validacaoSelecaoDataInicialEFinal,
} from "./SelecaoDataInicialEFinal";
import {
  type Id,
  type ErrosSelecao,
  type MedidaSelecionada,
  FORMATO_DATA_BANCO,
} from "../../../../../model";
import {
  type State,
  type ProcessadorPeriodo,
  isMedidaPontualSelecionada,
  getDiasUteis,
  getDataInicialSelecionada,
  getDataFinalSelecionada,
  getExibirSelecaoDatasEspecificas,
} from "../../../../../state";

export default function SelecaoDatasEspecificas() {
  const exibir = useSelector(getExibirSelecaoDatasEspecificas);
  if (!exibir) return null;

  return <SelecaoDataInicialEFinal />;
}

export const validacaoSelecaoDatasEspecificas = function(
  state: State
): ?ErrosSelecao {
  if (!getExibirSelecaoDatasEspecificas(state)) {
    return null;
  }

  return validacaoSelecaoDataInicialEFinal(state);
};

export const processarPeriodoDatasEspecificas: ProcessadorPeriodo = (
  periodo: Id,
  state: State,
  medidasSelecionadas: Array<MedidaSelecionada>
) => {
  const _medidasSelecionadas: Array<MedidaSelecionada> = [];

  const dataInicialSelecionada = Maybe(getDataInicialSelecionada(state))
    .map(data => data.format(FORMATO_DATA_BANCO))
    .getOrElse("");

  const dataFinalSelecionada = Maybe(getDataFinalSelecionada(state))
    .map(data => data.format(FORMATO_DATA_BANCO))
    .getOrElse("");

  if (isMedidaPontualSelecionada(state)) {
    const diasUteis: Array<string> = getDiasUteis(state) || [];
    const datasUteisEntreSelecao: Array<string> = diasUteis.filter(
      dia => dia >= dataInicialSelecionada && dia <= dataFinalSelecionada
    );

    medidasSelecionadas.forEach(medidaSelecionada => {
      datasUteisEntreSelecao.forEach(dataUtil => {
        _medidasSelecionadas.push({
          ...medidaSelecionada,
          periodo,
          dataInicial: dataUtil,
          dataFinal: dataUtil,
        });
      });
    });
  } else {
    medidasSelecionadas.forEach(medidaSelecionada => {
      _medidasSelecionadas.push({
        ...medidaSelecionada,
        periodo,
        dataInicial: dataInicialSelecionada,
        dataFinal: dataFinalSelecionada,
      });
    });
  }

  return _medidasSelecionadas;
};
